<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light shadow-sm bg-white"
    :class="hidden">
      <div class="container p-0">
        <div class="container-fluid p-0 ">
          <router-link :to="(isLineLoggedIn) ? `/line-liff` : `/`" tag="a" class="navbar-brand">
            <img src="/static/img/main-logo.svg"
                  class="logo"
                  :style="$mq.phone ? 'padding: 0 1rem' : ''"
                  height="38"
                  alt="BeNeat.co - ผู้ช่วยค้นหาแม่บ้านคุณภาพใกล้บ้านคุณ จองแม่บ้านออนไลน์ได้สะดวก รวดเร็ว พร้อมรับประกันคุณภาพ | Easy way to find your local cleaning expert">
          </router-link>
          <div id="mobile-display" class="d-flex">
              <button class="navbar-toggler"
              type="button"
              @click="toggleMenu"
              :class="{ 'open': isMenuOpen }"
              aria-controls="navbarSupportedContent-dev"
              :aria-expanded="isMenuOpen ? 'true' : 'false'"
              aria-label="Toggle navigation"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
          </div>
        </div>
        <!-- mobile -->
        <div class="p-0 collapse navbar-collapse mobile-menu-fullscreen" id="navbarSupportedContent-dev"
        :class="{ 'show': isMenuOpen }">
          <div class="d-flex justify-content-between align-items-center">
            <div v-if="user" class="d-flex gap-2 align-content-center pt-2 pb-4">
              <img v-lazy="user.picture" class="rounded-circle" height="40" width="40" alt="User Picture">
              <div class="d-flex flex-column align-items-start gap-2" >
                <span class="text-capitalize">{{ user.name }}</span>
                <!-- <SVGIcon class="text-secon" icon="location.svg" folder="icons" alt="location" /> -->
              </div>
            </div>
            <!-- <div class="d-flex gap-2">
              <button >
                waiting design
              </button>
              <button>
                message
              </button>
            </div> -->
          </div>
          <ul class="navbar-nav ml-auto" :class="hiddenWhenBooking">
            <li class="nav-item">
              <router-link @click="closeMenu" class="nav-link" to="/promotions">{{ $t('message.menu.promotions') }}</router-link>
            </li>
            <li class="nav-item">
              <router-link @click="closeMenu" class="nav-link" to="/pricing">{{ $t('message.menu.pricing') }}</router-link>
            </li>
            <li class="nav-item navbar-blog">
              <router-link class="nav-link link-icon" to="/blog">Blog</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link"
                href="https://line.me/R/ti/p/@BeNeat"
                target="_blank">
                {{ $t('message.menu.contact_customer_service') }}
              </a>
            </li>
            <template v-if="!user">
              <li class="nav-item" >
                <a class="nav-link" href="" @click.prevent="$emit('openModal', 'login')">
                  {{ $t('message.menu.login_signup') }}
                </a>
              </li>
            </template>
          </ul>
          <template v-if="user">
            <label class="m-0 text-capitalize" style="padding: 5% 0;" for="user-info">{{ $t('user_info.account') }}</label>
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <router-link @click="closeMenu" class="nav-link link-icon" :to="{ name: 'Edit Profile'}">
                  <SVGIcon
                    class=""
                    icon="user-circle.svg"
                    folder="icons"
                    alt="user" />
                  <div>{{ $t('user_info.edit_profile') }}</div> </router-link>
              </li>
              <li class="nav-item" >
                <router-link class="nav-link link-icon" to="/my-reservations">
                  <SVGIcon
                    class=""
                    icon="solar_calendar-outline.svg"
                    folder="icons"
                    alt="calendar" />
                  <div>{{ $t('message.menu.my_reservations') }}</div></router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link link-icon" to="/inbox">
                  <SVGIcon folder="icons" icon="solar_chat-round-line-outline.svg" alt="menu messages"/> 
                  <div>{{ $t('message.menu.messages') }}</div>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link link-icon" to="/notifications">
                  <i class="fal fa-bell" style="font-size: 24px;"></i> <div>{{ $t('message.menu.notifications') }}</div>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link link-icon" to="/user/listings">
                  <SVGIcon folder="icons" icon="hugeicons_home.svg" alt="menu address" /> 
                  <div>{{ $t('message.menu.my_listings') }}</div>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link link-icon" to="/user/company-address">
                  <SVGIcon icon="company-address.svg" folder="icons" alt="menu company address" /> 
                  <div>{{ $t('message.menu.company_address') }}</div>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link link-icon" to="/user/payment">
                  <SVGIcon icon="payment-method.svg" folder="icons" alt="menu payment method"/> 
                  <div>{{ $t('message.menu.payment_method') }}</div>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link link-icon" to="/user/invite">
                  <SVGIcon icon="gift.svg" folder="icons" alt="menu invite friends" /> 
                  <div>{{ $t('message.menu.invite_friends') }}</div>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link link-icon" to="/user/credits">
                  <SVGIcon icon="coins.svg" folder="icons" alt="menu coins" />
                  <div>
                    {{ $t('message.menu.my_credits_number', {
                      credits: user.totalCredits
                    }) }}
                  </div>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link link-icon" to="/user/my-vouchers">
                  <SVGIcon icon="discount-tag.svg" folder="icons" alt="menu my vouchers" />
                  <div>{{ $t('message.promo_code.my_vouchers') }}</div>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link link-icon" to="/user/personal-data-management">
                  <SVGIcon icon="shield-user.svg" folder="icons" alt="menu personal data management" />
                  <div style="text-wrap: wrap; line-height: normal;">{{ $t('message.menu.personal_data_management') }}</div>
                </router-link>
              </li>
            </ul>
          </template>
          <label class="m-0 text-capitalize" style="padding: 5% 0;" for="myDropdown">{{ $t('select_language')}}</label>
          <ul class="navbar-nav ml-auto">
            <li class="nav-item" style="position: relative;">
              <a class="nav-link dropdown-toggle" href="#" id="navbarLanguage" role="button" 
              data-toggle="dropdown"
                 aria-haspopup="true" aria-expanded="false">
                <img class="rounded-full" :src="flagImage">
                {{ $i18n.locale.toUpperCase() }}
              </a>
              <div class="dropdown-menu dropdown-menu-v2" aria-labelledby="navbarLanguage">
                <a class="dropdown-item" style="padding: 4% 10% !important;"
                   href="#"
                   @click.prevent="setLanguage('en')">
                  English
                </a>
                <a class="dropdown-item" style="padding: 4% 10% !important;"
                   href="#"
                   @click.prevent="setLanguage('th')">
                  ภาษาไทย
                </a>
            </div>
            </li>
          </ul>
          <label class="m-0 text-capitalize" style="padding: 5% 0;" for="myDropdown">{{ $t('message.menu.contact_with_line') }}</label>
          <ul class="navbar-nav ml-auto">
            <li class="nav-item line-content">
              <a @click="closeMenu" class="nav-link d-flex justify-content-center align-items-center text-capitalize" style="gap: 4px;" href="https://line.me/R/ti/p/@BeNeat" target="_blank" rel="noopener noreferrer">
                <img src="/static/img/icons/line-icon.svg" alt="Line Icon" style="width: 24px; height: 24px;">
                {{ $t('line_consult') }}
              </a>
            </li>
            <li id="sign-out" class="nav-item mt-5" v-if="user">
              <a class="nav-link d-flex gap-2 align-items-center justify-content-center text-capitalize"
                href="#"
                @click.prevent="$emit('openLogoutDialog')">
                <SVGIcon class="text-main-red" icon="logout-square.svg" folder="icons" alt="logout icon" />
                <div class="text-main-red" >{{ $t('message.menu.logout') }}</div>
              </a>
            </li>
          </ul>
        </div>
        <!-- desktop -->
        <div class="collapse navbar-collapse" id="navbarSupportedContent-dev" >
          <ul class="navbar-nav ml-auto" :class="hiddenWhenBooking">
            <li class="nav-item">
              <router-link class="nav-link" to="/promotions">{{ $t('message.menu.promotions') }}</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/pricing">{{ $t('message.menu.pricing') }}</router-link>
            </li>
            <li class="nav-item" v-if="user">
              <router-link class="nav-link" to="/my-reservations">{{ $t('message.menu.my_reservations') }}</router-link>
            </li>

            <li class="nav-item dropdown dropdown-md dropdown-box" v-if="user">
              <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
                {{ $t('message.menu.messages') }}
                <template v-if="newInbox">
                  <svg class="notification-alert">
                    <circle cx="3" cy="3" r="3"/>
                  </svg>
                </template>
              </a>
              <div class="dropdown-menu row custom-dropdown"
                   :class="[ !$mq.desktop ? 'user-menu-md' : 'user-menu-lg' ]">
                <div class="inbox-group">
                  <div class="col-12">
                    <div class="row text-order-title my-3">
                      <div class="col-6 p-0">
                        <strong>
                          {{ $t('message.menu.messages') }} <span v-if="inboxMessages.length > 0">({{ inboxMessages.length }})</span>
                        </strong>
                      </div>

                      <div class="col-6 p-0 text-right">
                        <router-link class="text-primary-link" to="/inbox">{{ $t('message.see_all') }} <i
                          class="fal fa-angle-right"></i></router-link>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <template v-if="isFetchingMessage">
                      <div class="text-center w-100 mb-4">
                        <div class="lds-ellipsis">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <router-link
                        class="no-style"
                        :to="convertUrl(chat)" v-for="(chat, index) in inboxMessages"
                        :key="index" @click.native="$emit('hasReadMessage', chat.last_message)">
                        <div class="d-flex justify-content-start align-items-center">
                          <div class="mr-3">
                            <img :src="$emit('showPicture', chat.professional)"
                                 width="50"
                                 class="rounded-circle img-fluid"
                                 v-if="chat.professional">
                          </div>

                          <div class="text-small">
                            <label class="mb-0">{{ chat.professional.full_name | firstName }}</label>
                            <span class="m-0">
                              <template v-if="chat.last_message.message_type_id !== 1">
                                 <span v-if="chat.last_message.sender_type === 'user'">
                                  {{ (chat.last_message.message_type_id === 2) ? $t('message.inbox.you_sent_photo') : $t('message.inbox.you_sent_location') }}
                                </span>
                                <span v-else>
                                  {{ (chat.last_message.message_type_id === 2) ? $t('message.inbox.sent_photo') : $t('message.inbox.sent_location') }}
                                </span>
                              </template>
                              <template v-else>
                                {{ chat.last_message.message }}
                              </template>
                            </span>
                            <div class="m-0 text-secondary">
                              <!-- {{ $emit('convertTimespan', chat.last_message.create_date) }} -->
                              {{ convertTimespan(chat.last_message.create_date) }}
                            </div>
                          </div>
                        </div>
                        <hr v-if="_.last(inboxMessages).id !== chat.id">
                      </router-link>
                    </template>
                    <p class="text-muted text-center"
                       v-if="!isFetchingMessage && inboxMessages.length <= 0">
                      {{ $t('message.menu.dropdown_message.empty_message') }}
                    </p>
                  </div>
                </div>
                <div class="col-12">
                  <hr>
                </div>
                <div class="notification-group">
                  <div class="col-12">
                    <div class="row text-order-title my-3">
                      <div class="col-6 p-0">
                        <strong>
                          {{ $t('message.menu.notifications') }} <span v-if="notifications.length > 0">({{ notifications.length }})</span>
                        </strong>
                      </div>
                      <div class="col-6 p-0 text-right">
                        <router-link class="text-primary-link" to="/notifications">{{ $t('message.see_all') }} <i
                          class="fal fa-angle-right"></i></router-link>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="text-center w-100 mb-4" v-if="isFetchingNoti">
                      <div class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                    <router-link
                      class="no-style"
                      :to="{name: 'My Reservation', params: {id: notification.notification_data.order_id}  }"
                      @click.native="$emit('hasReadActivity', notification.id)"
                      v-for="(notification, index) in notifications" :key="index">
                      <div class="d-flex justify-content-start align-items-center">
                        <div class="mr-3">
                          <img :src="notification.notification_data.professional_picture"
                               width="50"
                               class="rounded-circle img-fluid">
                        </div>
                        <div class="text-small">
                          <div>
                            <label class="mb-0">{{ notification.notification_data.professional_name | firstName }}</label>
                            {{ notification.activity_type_name }}
                            <span v-if="notification.notification_data.order_code">
                              #{{ notification.notification_data.order_code }}
                            </span>
                            <span v-else-if="notification.notification_data.order_id">
                              #{{ notification.notification_data.order_id }}
                            </span>
                          </div>
                          <div class="text-secondary">
                            <!-- {{ $emit('convertTimespan', notification.time) }} -->
                            {{ convertTimespan(notification.time) }}
                          </div>
                        </div>
                      </div>
                      <hr v-if="_.last(notifications).id !== notification.id">
                    </router-link>
                    <p class="text-muted text-center"
                       v-if="!isFetchingNoti && notifications.length <= 0">
                      {{ $t('message.menu.dropdown_message.empty_notification') }}
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <!-- Blog section -->
             <li class="nav-item navbar-blog">
              <router-link class="nav-link link-icon" to="/blog">Blog</router-link>
             </li>
            <!-- End blog section -->
            <!-- Login section -->
            <li class="nav-item" v-if="!user">
              <a class="nav-link" href="" @click.prevent="$emit('openModal', 'login')">
                {{ $t('message.menu.login_signup') }}
              </a>
            </li>
            <li class="nav-item dropdown" v-if="user">
              <a href="#" class="dropdown-toggle nav-link" id="navbarUser" data-toggle="dropdown" aria-expanded="false">
                <img v-lazy="user.picture" class="rounded-circle" width="30">
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarUser">
                <div :class="[ !$mq.desktop ? 'text-small user-menu-md overflow-auto' : 'user-menu-lg' ]">
                  <router-link class="dropdown-item" to="/user/edit">
                    <i class="fal fa-user"></i> {{ $t('message.menu.edit_profile') }}
                  </router-link>
                  <div class="dropdown-divider"></div>
                  <router-link class="dropdown-item" to="/user/listings">
                    <i class="fal fa-home"></i> {{ $t('message.menu.my_listings') }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/company-address">
                    <i class="fal fa-building"></i> {{ $t('message.menu.company_address') }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/payment">
                    <i class="fal fa-credit-card"></i> {{ $t('message.menu.payment_method') }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/notifications">
                    <i class="fal fa-bell"></i> {{ $t('message.menu.notification_settings') }}
                  </router-link>
                  <div class="dropdown-divider"></div>
                  <router-link class="dropdown-item" to="/rewards">
                    <i class="fal fa-trophy-alt"></i> {{ $t('message.menu.beneat_rewards') }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/invite">
                    <i class="fal fa-gift"></i> {{ $t('message.menu.invite_friends') }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/credits">
                    <i class="fal fa-wallet"></i> {{ $t('message.menu.my_credits_number', {
                    credits: user.totalCredits
                  }) }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/my-vouchers">
                    <i class="fal fa-ticket"></i> {{ $t('message.promo_code.my_vouchers') }}
                  </router-link>
                  <router-link class="dropdown-item" to="/user/personal-data-management">
                    <i class="fal fa-user-shield"></i> {{ $t('message.menu.personal_data_management') }}
                  </router-link>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item"
                    href="https://line.me/R/ti/p/@BeNeat"
                    target="_blank">
                    <i class="fal fa-comments"></i> {{ $t('message.menu.contact_customer_service') }}
                  </a>
                  <a class="dropdown-item"
                    href="#"
                    @click.prevent="$emit('openLogoutDialog')">
                    <i class="fal fa-sign-out"></i> {{ $t('message.menu.logout') }}
                  </a>
                </div>
              </div>
            </li>
            <!-- End login section -->
            <li class="nav-item dropdown" v-if="$mq.desktop">
              <a class="nav-link dropdown-toggle" href="#" id="navbarLanguage" role="button" data-toggle="dropdown"
                 aria-haspopup="true" aria-expanded="false">
                <img :src="flagImage">
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarLanguage">
                <a class="dropdown-item"
                   href="#"
                   @click.prevent="$emit('setLocaleLanguage', 'en')">
                  English
                </a>
                <a class="dropdown-item"
                   href="#"
                   @click.prevent="$emit('setLocaleLanguage', 'th')">
                  ภาษาไทย
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
</template>

<script>
import SVGIcon from '../../components/materials/SVGIcon.vue'
import moment from 'moment'
export default {
  name: 'MenuBar',
  props: {
    user: {
      type: Object,
      default: null
    },
    hidden: {
      type: [String, Array, Object],
      default: ''
    },
    hiddenWhenBooking: {
      type: [String, Array, Object],
      default: ''
    },
    flagImage: {
      type: String,
      default: ''
    },
    isLineLoggedIn: {
      type: Boolean,
      default: false
    },
    newInbox: {
      type: Boolean,
      default: false
    },
    inboxMessages: {
      type: Array,
      default: () => []
    },
    isFetchingMessage: {
      type: Boolean,
      default: false
    },
    notifications: {
      type: Array,
      default: () => []
    },
    isFetchingNoti: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SVGIcon
  },
  data () {
    return {
      isMenuOpen: false,
      selectedLanguage: this.$i18n.locale.toUpperCase()
    }
  },
  methods: {
    setLanguage (lang) {
      this.selectedLanguage = lang.toUpperCase()
      this.$i18n.locale = lang
      // this.$emit('languageChanged', lang)
    },
    toggleMenu () {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu () {
      this.isMenuOpen = false
    },
    convertTimespan (time) {
      return moment(time).fromNow()
    },
    convertUrl (chat) {
      if (chat) {
        return `/message?cid=${chat.id}&pid=${chat.professional_id}`
      } else if (chat.last_message.sender_type === 'professional') {
        return `/message?cid=0&pid=${chat.last_message.sender_id}`
      }
    }
  },
  watch: {
    '$route' () {
      if (this.isMenuOpen) {
        this.closeMenu()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../static/sass/page/ac_cleaning.scss";

.relative {
  position: relative;
}
.navbar-toggler {
  display: flex; 
  align-items: flex-end;
  flex-direction: column;
  justify-content: space-around;
  width: 54px;
  height: auto; 
  cursor: pointer;
  background-color: #F5F5F5;
  border: none; 

  &:hover {
    background-color: #ECEFF6;
  }
}

.navbar-toggler span {
  display: block;
  width: 100%;
  height: 3px;
  margin: 4px 0;
  background-color: #000000;
  border-radius: 2px;
  transition: all 0.3s ease-in-out;
}

.navbar-toggler span:nth-child(2) {
  width: 70%;
}

.navbar-toggler.open span:nth-child(1) {
  transform: translateY(11px) rotate(45deg);
}

.navbar-toggler.open span:nth-child(2) {
  opacity: 0;
}

.navbar-toggler.open span:nth-child(3) {
  transform: translateY(-11px) rotate(-45deg);
}

#mobile-display {
  @media only screen and (min-width: 990px) {
    display: none !important;
  }
}

.mobile-menu-fullscreen {
  border-top: solid 1px #F3F3F3;
  margin-top: 2%;
  padding: 5% 1% !important;
  overflow-y: scroll;
  height: 85vh;
  z-index: 1;
  // @media only screen and (min-width: 750px) {
  //   height: 70vh;
  // }
  @media only screen and (min-width: 990px) {
    height: 100%;
    display: none !important;
  }

  /* --- Custom Scrollbar Styles --- */
  &::-webkit-scrollbar {
    display: none; //if want custom scrollbar hide this line
    width: 2px; 
    background-color: #f5f5f5;
  }

  /* This targets the scrollbar thumb (the draggable part) */
  &::-webkit-scrollbar-thumb {
    background-color: #888; /* Darker gray for the thumb */
    border-radius: 10px; /* Rounded corners for the thumb */
    border: 2px solid #f5f5f5; /* Adds a border that matches the track for a "floating" effect */
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Even darker gray on hover */
  }

  &::-webkit-scrollbar-corner {
    background: #f5f5f5; /* Matches the track color */
  }
  /* --- End Custom Scrollbar Styles --- */
}

.mobile-menu-fullscreen ul {
  gap: 10px;
}

.mobile-menu-fullscreen ul li {
  padding: 0.5rem 1rem;
  background: #ECEFF6;
  border-radius: 50px;

  :hover {
    opacity: 0.5;
  }
}

.dropdown-menu-v2 {
  border: 0;
  background: #ECEFF6;
  position: absolute;
  width: 100%;
  border-radius: 15px;
  opacity: 1 !important;
  // &:hover {
  //   background: #f9fafd;
  // }
}

.dropdown-item-v2 {
  display: block;
  width: 100%;
  padding: 10px 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.line-content {
  background-color: #00A42C24 !important;
  transition: all 0.3s ease-in;

  &:hover {
    border: solid 1px #00A42C;
  }
}

.line-content a {
  font-size: 16px;
  line-height: 10px;
  letter-spacing: 0px;
  color: #00A42C !important;
}

#sign-out {
  background-color: #DF3B5714;
  transition: all 0.3s ease-in;
}

#sign-out a {
  font-size: 16px;
  line-height: 10px;
  letter-spacing: 0px;
  color: $main-red-color;
}

#navbarSupportedContent-dev a {
  text-wrap: nowrap;
  color: #151411;

}

.link-icon {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/materials/MenuBar.vue